module.exports = __webpack_public_path__ + "8e64280d08fae8e75d64b0b7defeecac.png";